import { Popover, PopoverButton, PopoverPanel, Transition } from '@headlessui/react';
import cx from 'clsx';
import { Fragment } from 'react';
import { IDown } from 'ui/component/Icons.tsx';

type Props = {
  title: string;
  children: React.ReactNode;
  justify?: 'left' | 'center' | 'right';
};

export const HeaderMenu = ({ children, title, justify = 'center' }: Props) => {
  return (
    <div className="relative flex max-w-sm items-center justify-self-end">
      <Popover className="relative">
        <PopoverButton className="group header-menu-item flex items-center justify-center outline-hidden">
          <span className="whitespace-nowrap text-lg">{title}</span>
          <IDown className="ml-1 size-5 text-white transition duration-150 ease-in-out" aria-hidden="true" />
        </PopoverButton>
        <Transition
          as={Fragment}
          enter="transition ease-out duration-200"
          enterFrom="opacity-0 translate-y-1"
          enterTo="opacity-100 translate-y-0"
          leave="transition ease-in duration-150"
          leaveFrom="opacity-100 translate-y-0"
          leaveTo="opacity-0 translate-y-1"
        >
          <PopoverPanel
            className={cx(
              'absolute z-50 mt-6 w-48 shadow-lg',
              justify === 'left' && 'left-0 translate-x-0',
              justify === 'center' && 'left-1/2 -translate-x-1/2',
              justify === 'right' && 'right-0 translate-x-0',
            )}
          >
            <div className="relative flex flex-col gap-4 bg-white p-4 shadow-lg outline-hidden">{children}</div>
          </PopoverPanel>
        </Transition>
      </Popover>
    </div>
  );
};
